<div *ngIf="canAdd && kontakte.length === 0">
  <button userRoleNeeded_hidden="Kontakte_Schreiben" *ngIf="canAdd" type="button"
    class="btn btn-block btn-sm btn-warning" (click)="onClickAddKontakt()"><span
      class="glyphicon glyphicon-plus"></span> Kontakt anlegen</button>
</div>
<div userRoleNeeded_hidden="Kontakte_Lesen" class="panel panel-primary" *ngIf="canAdd && kontakte.length !== 0">
  <div class="panel-heading clearfix">
    <div class="panel-title pull-left">Alle Kontakte</div>
    <div class="panel-title pull-right" userRoleNeeded_hidden="Kontakte_Schreiben">
      <button *ngIf="canAdd" type="button" class="btn btn-sm btn-warning" (click)="onClickAddKontakt()"><span
          class="glyphicon glyphicon-plus"></span> Kontakt anlegen</button>
      <small class="text-warning" *ngIf="!canAdd">Bitte vorher speichern!</small>
    </div>
  </div>
  <div class="panel-body">
    <dx-sortable lass="row" dragDirection="vertical" itemOrientation="vertical" (onDragStart)="onDragStart($event)"
      (onReorder)="onReorder($event)">

      <cz-kontakt-detail #kontaktComponent class="{{class}}" *ngFor="let kontakt of kontakte; let i = index;"
        [kontakt]="kontakt" [dragEnabled]="!kontaktEdit" (onKontaktEdit)="onKontaktEdit($event)"
        (onKontaktRemove)="handleKontaktRemove($event)" (onEmailSend)="onEmailSendFinished()" [sortableIndex]="i">
      </cz-kontakt-detail>

    </dx-sortable>
  </div>
</div>

<cz-kontakt-modal [kontakt]="kontaktToEdit" [showModal]="showModal" (onCloseKontaktModal)="handleKontaktModalClose()"
  (onKontaktHasChanged)="handleKontaktHasChanged($event)"></cz-kontakt-modal>
